import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// store
import AppStore from "@/app-store";
import Store from "@/core/reducers/SimpleServiceStore";
// actions
import ClientContentsServiceAction from "@/cms/actions/services/ClientContentsServiceAction";
// types
import TOdataQueryOptions from "@/core/types/TOdataQueryOptions";
import TBaseReduxStoreState from "@/core/types/TBaseReduxStoreState";
import TClientContentList from "@/cms/types/TClientContentList";


type TUseContentList = {

    search: (searchPayload:any ) => void;

} & TBaseReduxStoreState<TClientContentList[]|null>

const useContentList = ( unqKey:string ):TUseContentList => {
    const dispatch = useDispatch();

    const _unqKey = `${unqKey}CL`;

    const clientContentsServiceAction = new ClientContentsServiceAction(dispatch, _unqKey);
    AppStore.reducerManager.add(_unqKey, Store(_unqKey, clientContentsServiceAction.serviceCode));
    const payload = useSelector((state:any) => state?.[_unqKey]?.list, shallowEqual);
    const webApplicationLanguageCode = useSelector((state:any) => state.CoreStore.language?.payload?.code, shallowEqual);

    useEffect(() => { return () => { AppStore.reducerManager.remove(_unqKey); } }, []);

    const search = (searchPayload:any ) => {
        let queryOptions:TOdataQueryOptions = {
            count: true,
            filter: searchPayload.filters,
            orderBy: searchPayload.orders,
            top: searchPayload.top,
            skip: searchPayload.skip,
            expands: ["tags"]
        }
        clientContentsServiceAction.search({ servicePayload: { queryOptions, language: webApplicationLanguageCode } });
    }

    return {
        ...payload,
        search,
    }
}

export default useContentList;
